import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class Lengths extends Component {
  render() {
    return (
      <EntityList apiRoute='api/lengths' title='Remorque - Longueurs' editTitle='Longueur' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Valeur', Column: 'Value'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default Lengths;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/lengths.js
 **/